var map = {
	"./background.png": 285,
	"./barsov_kids_tampa.png": 3741,
	"./brasov_coltea.png": 8196,
	"./brasov_grand_fitness.png": 9460,
	"./brasov_padel_palace.png": 2654,
	"./bucuresti_dinamo.png": 6390,
	"./bucuresti_fit_goo.png": 2797,
	"./bucuresti_victory_cup.png": 3714,
	"./chiajna_concordia.png": 9851,
	"./circuit_works.png": 7736,
	"./cluj_viitorul.png": 4707,
	"./constanta_sharks_kickbox.png": 1803,
	"./dobresti_unirea.png": 1513,
	"./ellipse_hovered.png": 8073,
	"./ellipse_simple.png": 4729,
	"./ploiesti_daniel_chirita.png": 7111,
	"./ro_frb.png": 8620,
	"./sighet_club_sportiv_scolar.png": 5751,
	"./sighet_csm.png": 3219,
	"./stefanesti_club_sportiv.png": 5564,
	"./uk_domocos_fitness.png": 6879,
	"./uk_romania_fc.png": 4547,
	"./valcea_fairplay.png": 9921,
	"./voluntari_basketball_club.png": 7952,
	"./voluntari_football_club.png": 7775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4995;